import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/views/Home.vue'
import { PROJECT_NAME } from '@/constant'
import articles from '@/data/articles'
import { types } from '@/components/PageTransition'

const BASE_URL = (function (projectName) {
  if (process.env.NODE_ENV !== 'production') {
    return process.env.BASE_URL
  }
  let url = window.location.pathname
  let paths = url.split('/')
  let index = paths.lastIndexOf(projectName)
  let baseUrl = (index !== -1) ? paths.slice(0, index + 1).join('/') : url
  return baseUrl
})(PROJECT_NAME)

const GA_ROOT_PATH = BASE_URL.replace(/\/$/, '')

Vue.use(Router)

export const router = new Router({
  mode: 'history',
  base: BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
      meta: {
        transitionType: types.SLIDE
      }
    },
    {
      path: '/article',
      name: 'article',
      redirect: '/',
      component: () => import(/* webpackChunkName: "article" */ '@/views/Article'),
      children: [
        ...articles.map(article => {
          return {
            path: `${article.id}`,
            name: `article-${article.id}`,
            component: () => import(/* webpackChunkName: "article" */ `@/views/articles/Article${article.id}`),
            beforeEnter: (to, from, next) => {
              if (/^\/article\/\d+\/$/.test(to.path)) {
                next({
                  name: `article-${article.id}`
                })
              }
              next()
            },
            meta: {
              transitionType (to, from) {
                const toPath = to.path.split('/')
                const fromPath = from.path.split('/')
                const toDepth = toPath.length
                const fromDepth = fromPath.length
                const toArticleId = Number(toPath[toPath.length - 1])
                const fromArticleId = Number(fromPath[toPath.length - 1])
                if (!toArticleId) {
                  // console.log('[article transition] path', fromPath, '->', toPath)
                  return (toDepth.length < fromDepth.length) ? types.SLIDE_RIGHT : types.SLIDE_LEFT
                }
                // console.log('[article transition] articleId', fromArticleId, '->', toArticleId)
                return (toArticleId < fromArticleId) ? types.SLIDE_RIGHT : types.SLIDE_LEFT
              }
            }
          }
        })
      ]
    },
    {
      path: '*',
      redirect: '/'
    }
  ],
  scrollBehavior (to, from, savedPosition) {
    // if (savedPosition) {
    //   return savedPosition
    // } else {
    //   return { x: 0, y: 0 }
    // }
    let scorllPosition = { x: 0, y: 0 }
    if (to.name === 'home' && savedPosition) {
      scorllPosition = savedPosition
    }
    return new Promise(resolve => setTimeout(() => resolve({ ...scorllPosition }), 400))
  }
})

router.onError(err => {
  console.log(err)
})

router.beforeEach((to, from, next) => {
  let path = to.path.replace(/\/$/, '')
  let articlePattern = /^\/article\/(\d+)\/?/
  let title = '選戰蝴蝶效應 | 看懂2020總統立委大選'
  let subtitle = ''
  if (articlePattern.test(path)) {
    let id = Number(path.replace(articlePattern, '$1'))
    if (!isNaN(id)) {
      let article = articles[id - 1] || null
      subtitle = !article ? '' : article.title.replace('\n', ' ')
    }
  }
  document.title = !subtitle ? title : `${subtitle} | ${title}`
  return next()
})

router.beforeResolve((to, from, next) => {
  return next()
})

router.afterEach(function (to, from) {
  // ga record
  Vue.ga('newmedia.send', {
    'hitType': 'pageview',
    'page': `${GA_ROOT_PATH}${to.path}`,
    'title': document.title
  })
})

console.log('[vue-router] base', router.options.base)

export default router
